import MenuTile from './MenuTile';

export default MenuTile;
